<template>
    <div class="topic-detail">
        <short-video-list-skeleton v-if="loading"></short-video-list-skeleton>

        <div class="list" :style="'min-height:100vh;background-size: 100% 100%;background-image: url('+topic.footer_img+')'" v-else>

<!--            <img :src="topic.logo" v-if="topic.id<3" class="logo" style="float: right;margin-top: 15px" alt/>-->

            <div class="title" :style="topic.id<3 ? 'opacity: 0' : ''">
<!--                <img :src="topic.logo" class="logo" :style="topic.id==1 ? 'opacity: 0' : ''" alt/>-->
                <div v-if="topic.id != 42"> </div>
                <div v-else :style="'color:'+topic.title_color+';font-size:'+topic.title_font_size">{{ topic.title }}</div>
            </div>
            <div class="clearfix"></div>

            <div class="topic-detail-content">
                <div class="swipe topic-detail-content-img">
                    <van-swipe :autoplay="3000" indicator-color="#fff" touchable ref="swipe">
                        <van-swipe-item v-for="(item,i) in banners" :key="i">
                            <a :href="item.target_url.replace('https://byh.dr-gobroad.com','https://byh.dr-gobroad.com')">
                                <img :src="item.img" alt/>
                            </a>
                        </van-swipe-item>
                    </van-swipe>
                </div>
                <div class="topic-detail-content-text">
                    <div :class="'topic-detail-content-text-box true'" v-html="topic.content"></div>
                </div>
            </div>

            <div class="global-back">
                <img src="/static/third/detail_back_btn.svg" @click="$router.back()" alt="">
            </div>

            <!-- 联系我们 -->
            <div class="contact" v-if="topic.email && topic.qrcode">
                <div class="name">联系我们</div>
                <div class="info" v-for="item in mobile">
                    <!--                    电话：<span>13261578987</span>-->
                    <span>{{ item }}</span>
                </div>
                <div class="info" v-if="topic.email!=''">
                    邮箱：
                    <span>{{ topic.email }}</span>
                </div>
                <div class="info">
                    联系小助手：
                    <span>{{ topic.qrcode_name }}</span>
                </div>
                <img class="qr-code" :src="topic.qrcode" alt/>
            </div>
        </div>
    </div>
</template>

<script>
import Interface from "@/util/interface"
import shortVideoListSkeleton from "@/skeleton/shortVideoListSkeleton"

export default {
    components: {
        'short-video-list-skeleton': shortVideoListSkeleton
    },
    data() {
        return {
            banners: [],
            id: 0,
            activeTab: 0,
            showNum: 4,
            value: '',
            topic: {
                footer_img: ""
            },
            loading: true,
            modules: [],
            all: false,
            mobile: [],
        }
    },
    methods: {
        handleHonor(item) {
            if (item.key == 'study_group') {
                this.$router.push({
                        name: 'study-group-recruitment',
                        query: {
                            topic_id: this.id
                        }
                    }
                )
            }else if(item.key == 'column'){
                this.$router.push({
                    name : "topic-column",
                    query : {
                        topic_id : this.id,
                        topic_subject_id : item.id
                    }
                })
            }
        },
        fetch(scene) {
            if (scene === 'detail') {
                Interface.getData('get', Interface.topic.detail + this.id).then((res) => {
                    this.topic = res.data

                    let desc = ""
                    switch (this.topic.id) {
                        case 2:
                            desc = "精准医疗，诊断先行"
                            break
                        case 21:
                            desc = "零门槛开展临床研究的学术交流专区"
                            break
                        case 4:
                            desc = "把脉国际学术新知"
                            break
                        default:
                            desc = this.topic.desc
                            break
                    }
                    Interface.getShareInfo(this,this.topic.title, this.topic.cover_img, this.topic.desc,"",false,{isTopic:true})

                    this.loading = false

                    let column = []
                    let study_group = []
                    let honorary = []

                    this.topic.modules.forEach(val => {
                        if (val.key == 'column') {
                            column.push(val)
                        } else if (val.key == 'study_group') {
                            study_group.push(val)
                        } else if (val.key == 'honorary') {
                            honorary.push(val)
                        }
                    })
                    this.modules = [].concat(column, study_group, honorary)
                    this.mobile = this.topic.mobile.split(",")
                    this.banners = this.topic.banners
                })
            }
        },
        goNews(item) {
            if (item.content_type == 1) {
                this.$router.push({
                    name: 'meeting-news-detail',
                    params: {
                        id: item.id
                    }
                })
            } else {
                location.href = item.target_url
            }
        }
    },
    async created() {
        this.id = this.$route.params.id
        await this.fetch('detail')
        sessionStorage.removeItem("search_data")
        Interface.footPrint(15,this.id)
    },
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/topic/topic-desc/index.vue